


















import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { MentionParticipant } from '../types/mention-participant';

export default defineComponent({
  props: {
    mentionParticipants: {
      type: Array as PropType<MentionParticipant[]>,
      required: true,
    },
    bottom: {
      type: Number,
      default: 10,
    },
    selectedIndex: {
      type: Number,
      required: true,
    },
  },
  setup(_, { emit }) {
    const close = () => {
      emit('close');
    };

    return {
      close,
    };
  },
});
